import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import { Spin } from "antd";
import MainLayout from "@/layouts/MainLayout";
import RequireAuth from "@/components/RequireAuth";
import LoginPage from "@/pages/Login";

// 业务页面（懒加载）
const DashboardPage = lazy(() => import("@/pages/Dashboard"));
const CaseListPage = lazy(() => import("@/pages/Cases/CaseList"));
const CaseEditPage = lazy(() => import("@/pages/Cases/CaseEdit"));
const QuestionListPage = lazy(() => import("@/pages/Questions/QuestionList"));
const QuestionEditPage = lazy(() => import("@/pages/Questions/QuestionEdit"));
const LevelListPage = lazy(() => import("@/pages/Levels/LevelList"));
const LevelEditPage = lazy(() => import("@/pages/Levels/LevelEdit"));
const CategoryListPage = lazy(() => import("@/pages/Categories/CategoryList"));
const HomeRecListPage = lazy(() => import("@/pages/HomeRecs/HomeRecList"));
const MediaLabPage = lazy(() => import("@/pages/MediaLab/MediaLab"));
const FaqListPage = lazy(() => import("@/pages/Faqs/FaqList"));
const MemberListPage = lazy(() => import("@/pages/Members/MemberList"));
const ReviewQueuePage = lazy(() => import("@/pages/Review/ReviewQueue"));
const AuditLogPage = lazy(() => import("@/pages/AuditLog"));
const SettingsPage = lazy(() => import("@/pages/Settings"));

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <MainLayout />
          </RequireAuth>
        }
      >
        <Route
          index
          element={
            <Suspense fallback={<Spin />}>
              <DashboardPage />
            </Suspense>
          }
        />
        <Route path="cases">
          <Route
            index
            element={
              <Suspense fallback={<Spin />}>
                <CaseListPage />
              </Suspense>
            }
          />
          <Route
            path="new"
            element={
              <Suspense fallback={<Spin />}>
                <CaseEditPage />
              </Suspense>
            }
          />
          <Route
            path=":id"
            element={
              <Suspense fallback={<Spin />}>
                <CaseEditPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="questions">
          <Route
            index
            element={
              <Suspense fallback={<Spin />}>
                <QuestionListPage />
              </Suspense>
            }
          />
          <Route
            path="new"
            element={
              <Suspense fallback={<Spin />}>
                <QuestionEditPage />
              </Suspense>
            }
          />
          <Route
            path=":id"
            element={
              <Suspense fallback={<Spin />}>
                <QuestionEditPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="levels">
          <Route
            index
            element={
              <Suspense fallback={<Spin />}>
                <LevelListPage />
              </Suspense>
            }
          />
          <Route
            path="new"
            element={
              <Suspense fallback={<Spin />}>
                <LevelEditPage />
              </Suspense>
            }
          />
          <Route
            path=":id"
            element={
              <Suspense fallback={<Spin />}>
                <LevelEditPage />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="categories"
          element={
            <Suspense fallback={<Spin />}>
              <CategoryListPage />
            </Suspense>
          }
        />
        <Route
          path="home-recs"
          element={
            <Suspense fallback={<Spin />}>
              <HomeRecListPage />
            </Suspense>
          }
        />
        <Route
          path="media-lab"
          element={
            <Suspense fallback={<Spin />}>
              <MediaLabPage />
            </Suspense>
          }
        />
        <Route
          path="faqs"
          element={
            <Suspense fallback={<Spin />}>
              <FaqListPage />
            </Suspense>
          }
        />
        <Route
          path="members"
          element={
            <Suspense fallback={<Spin />}>
              <MemberListPage />
            </Suspense>
          }
        />
        <Route
          path="review"
          element={
            <Suspense fallback={<Spin />}>
              <ReviewQueuePage />
            </Suspense>
          }
        />
        <Route
          path="audit-log"
          element={
            <Suspense fallback={<Spin />}>
              <AuditLogPage />
            </Suspense>
          }
        />
        <Route
          path="settings"
          element={
            <Suspense fallback={<Spin />}>
              <SettingsPage />
            </Suspense>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
